(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rw-store-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const header = document.getElementById('rw-store-chrome');
    if (!header) return;
    const panels = [...header.querySelectorAll('.rw-site-disclosure')];
    header.addEventListener('click', event => {
      const summary = event.target.closest('summary');
      if (!summary) return;
      panels.forEach(panel => { if (panel !== summary.parentElement) panel.open = false; });
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) panels.forEach(panel => { panel.open = false; });
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const panel = event.target.closest('details[open]');
      if (panel) { panel.open = false; panel.querySelector('summary').focus(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
